export default __webpack_public_path__ + "static/media/BodyShop.0ddd7c95.webp";